import tokenStorage from "../services/tokenStorage";
import { logout } from "./oauthActions";
import { getApplication } from "../reducers";
import { ActionTypes } from "../constants";

export const asyncAction = ({appCode, actionTypes, serviceAction, callback = null, ...params}) => (dispatch, getState) => {
    const { request, success, failure } = actionTypes;
    const app = getApplication(getState(), appCode);
    if (!!app && !!app.serviceURL && !!app.uuid) {
        const serviceFunction = (accessToken) => {
            if (!!request) {
                dispatch({type: request, payload: {...params}});
            }
            serviceAction({serviceURL: app.serviceURL, accessToken, ...params}).then(
                response => {
                    dispatch({type: success, data: response, payload: {...params}});
                    if (!!callback) {
                        callback(response);
                    }
                },
                error => {
                    if (!!error.response && error.response.status === 401) {
                        if (!!error.response.headers['www-authenticate']) {
                            error.response.data = [
                                    ...error.response.headers['www-authenticate'].matchAll(/\b([^=]+)=(['"])(.*?)\2/g)
                                ].reduce((o, matches) => ({...o, [matches[1]]: matches[3]}), {});
                            error.response.data.error = `[${appCode}] ${error.response.data.error}`;
                        }
                    }
                    if (!!failure) {
                        const data = error.response?.data || {};
                        const code = data.error?.code || error.response?.status || null;
                        let message = data.error || data.error_description || data.message || '';
                        if (typeof message === 'object' && message !== null) {
                            message = message.message || '';
                        }
                        dispatch({
                            type: failure,
                            payload: {...params},
                            code,
                            message: `${appCode} Error: ${message}`,
                            details: data.error?.message?.details || []
                        });
                    } else {
                        throw error; // handle somewhere else
                    }
                }
            );
        };
        tokenStorage.getSSOToken(app.uuid).then(token => serviceFunction(token));

    }
};

export const asyncCall = (appCode, serviceFunction) => (dispatch, getState) => {
    const app = getApplication(getState(), appCode);
    if (!!app && !!app.serviceURL && !!app.uuid) {
        tokenStorage.getSSOToken(app.uuid).then(token => serviceFunction(token, app.serviceURL));
    }
}

export const clearErrors = (dispatch) => dispatch({type: ActionTypes.CLEAR_ERRORS});
export const clearSuccessMessage = (dispatch) => dispatch({type: ActionTypes.CLEAR_SUCCESS_MESSAGE});

export const logoutOn401 = (dispatch) => (error) => {
    if (!!error.response && error.response.status === 401 ) {
        logout(dispatch);
        window.location.reload();
    }
};
